import { apiFetch } from './apiFetch'

// Sends a JSON request and throws on any non-2xx, so callers only have to handle
// the success path. Used by the CRUD endpoints; the act endpoints go through
// postAction instead, which needs the status and message off a failed response.
export async function fetchWithAuth(
  path: string,
  token: string,
  options?: RequestInit,
): Promise<Response> {
  const response = await apiFetch(path, token, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

  if (!response.ok) {
    throw new Error(`API error ${response.status}: ${response.statusText}`)
  }

  return response
}
